// src/components/tasks/ui/SubtaskCreateDialogUI.tsx
import { cn } from "@/lib/utils"

export const subtaskCreateTheme = {
  // Основное окно диалога — стекло
  dialogContent: "bg-purple-950/70 backdrop-blur-2xl border border-purple-300/40 text-white max-w-2xl max-h-[90vh] overflow-y-auto",

  // Поля формы — glass
  formInput: "bg-purple-950/60 border-purple-300/40 focus:border-purple-400 focus:ring-purple-400 text-white",
  formTextarea: "bg-purple-950/60 border-purple-300/40 focus:border-purple-400 focus:ring-purple-400 text-white",

  // Select
  selectTrigger: "bg-purple-950/60 border-purple-300/40 text-white hover:border-purple-400",
  selectContent: "bg-purple-950/90 border-purple-300/40 backdrop-blur-2xl text-white shadow-2xl",

  // Бейджи
  badgeCoAssignee: "bg-purple-600 text-white",
  badgeObserver: "bg-amber-700/80 text-white",

  // Область загрузки файла — glass
  fileUploadArea: "flex items-center gap-2 bg-purple-950/60 hover:bg-purple-950/80 text-purple-200 border border-purple-300/40 px-4 py-2 rounded-2xl transition cursor-pointer",

  // Кнопка создания
  createButton: "bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white rounded-2xl",
} as const